import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Trans } from "react-i18next";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Minutes from "./Minutes.js";
import Hourly from "./Hourly.js";
import Daily from "./Daily.js";
import Weekly from "./Weekly.js";
import Monthly from "./Monthly.js";
import cronstrue from "cronstrue";
import SwipeableViews from "react-swipeable-views";
import Paper from "@material-ui/core/Paper";
import CardContent from "@material-ui/core/CardContent";
import Radio from "@material-ui/core/Radio";
import FormControlLabel from "@material-ui/core/FormControlLabel";

const useStyles = makeStyles((theme) => ({}));
function CreateCronExpression(props) {
  // const [crossExpression, setCrossExpression] = useState(null);
  const [tabValue, setTabValue] = useState(0);
  const [crossExpression, setCrossExpression] = useState([
    "0",
    "0/1",
    "*",
    "1/1",
    "*",
    "?",
    "*",
  ]);
  useEffect(
    () => {
      let cron;
      if (tabValue === 0) {
        //"0", "0/1", "*", "1/1", "*", "?", "*" -> 0/1, the 1 is the miniute
        cron = ["0", "0/1", "*", "?", "*", "*"];
      } else if (tabValue === 1) {
        //0 0 */2 ? * *	  -> 2= every 2 hours -> 0 0 6/2 ? * * * -> every 2 hours starting at 6.
        cron = ["0", "0", "0/1", "1/1", "*", "?", "*"];
      } else if (tabValue === 2) {
        //0 0 12 */6 * ?	 -> every 6 days at 12
        cron = ["0", "0", "0", "*/1", "*", "?"];
      } else if (tabValue === 3) {
        //0 0 12 ? * SUN,SAT	 -> Every Saturday and Sunday at noon
        cron = ["0", "0", "0", "?", "*", "MON", "*"];
      } else if (tabValue === 4) {
        cron = ["0", "0", "0", "1", "1/1", "?", "*"];
      }
      setCrossExpression(cron);
    },
    [tabValue]
  );
  const returnValue = (first, second) => {
    let cron;
    if (tabValue === 0) {
      cron = ["0", "0/" + first, "*", "?", "*", "*"];
    } else if (tabValue === 1) {
      cron = ["0", second.minutes, "*/" + first, "?", "*", "*"];
    } else if (tabValue === 2) {
      cron = ["0", second.minutes, second.hours, "*/" + first, "*", "?"];
    } else if (tabValue === 3) {
      cron = [
        "0",
        second.minutes,
        second.hours,
        "?",
        "*",
        createDayString(first),
        "*",
      ];
    } else if (tabValue === 4) {
      cron = ["0", second.minutes, second.hours, first, "1/1", "?", "*"];
    }
    setCrossExpression(cron);
  };
  const createDayString = (days) => {
    let string = "";
    if (days.MON) {
      string = string + "MON,";
    }
    if (days.TUE) {
      string = string + "TUE,";
    }
    if (days.WED) {
      string = string + "WED,";
    }
    if (days.THU) {
      string = string + "THU,";
    }
    if (days.FRI) {
      string = string + "FRI,";
    }
    if (days.SAT) {
      string = string + "SAT,";
    }
    if (days.SUN) {
      string = string + "SUN,";
    }
    return string;
  };
  const getValueString = () => {
    let valString = "";
    crossExpression.map((item) => {
      valString = valString + item + " ";
    });
    let val = cronstrue.toString(valString);
    return val;
  };
  const changeRadio = (e) => {
    setTabValue(Number(e.currentTarget.value));
  };
  const classes = useStyles();
  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  return (
    <Dialog open={props.open}>
      <DialogTitle>
        <Trans i18nKey="Pick a schedule" />
      </DialogTitle>
      <DialogContent>
        {/* <AppBar position="static">
          <Tabs
            value={tabValue}
            onChange={(e, newVal) => setTabValue(newVal)}
            aria-label="simple tabs example"
          >
            <Tab label="Minutes" />
            <Tab label="Hourly" />
            <Tab label="Daily" />
            <Tab label="Weekly" />
            <Tab label="Monthly" />
          </Tabs>
        </AppBar> */}

        <FormControlLabel
          control={
            <Radio
              checked={tabValue === 0}
              onChange={changeRadio}
              value={0}
              name="radio-button-demo"
            />
          }
          label="Minutes"
        />
        <FormControlLabel
          control={
            <Radio
              checked={tabValue === 1}
              onChange={changeRadio}
              value={1}
              name="radio-button-demo"
            />
          }
          label="Hourly"
        />
        <FormControlLabel
          control={
            <Radio
              checked={tabValue === 2}
              onChange={changeRadio}
              value={2}
              name="radio-button-demo"
            />
          }
          label="Daily"
        />
        <FormControlLabel
          control={
            <Radio
              checked={tabValue === 3}
              onChange={changeRadio}
              value={3}
              color="default"
              name="radio-button-demo"
            />
          }
          label="Weekly"
        />
        <FormControlLabel
          control={
            <Radio
              checked={tabValue === 4}
              onChange={changeRadio}
              value={4}
              color="default"
              name="radio-button-demo"
            />
          }
          label="Monthly"
        />
        <SwipeableViews style={{}} index={tabValue}>
          <Minutes returnValue={returnValue} />
          <Hourly returnValue={returnValue} />
          <Daily returnValue={returnValue} />
          <Weekly returnValue={returnValue} />
          <Monthly returnValue={returnValue} />
        </SwipeableViews>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div style={{ width: "100%" }} />
          <Paper style={{ marginTop: 20, width: "100%" }} variant="outlined">
            <CardContent>
              <Typography variant="subtitle1">{getValueString()}</Typography>
            </CardContent>
          </Paper>
          <div style={{ width: "100%" }} />
        </div>
      </DialogContent>
      <DialogActions>
        <Button color="primary" id="apiLocation-save" onClick={props.close}>
          <Trans i18nKey="global_cancel" />
        </Button>
        <Button
          color="primary"
          id="apiLocation-save"
          onClick={() => props.onAccept(crossExpression, getValueString())}
        >
          <Trans i18nKey="global_ok" />
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default CreateCronExpression;
